const { createApp, ref, component, watch, onMounted, reactive, onBeforeMount } = Vue;

const app = createApp({
	name: "AddonApp",
	setup() {
		const addOnConfigState = ref(addOnData);
		const isLoading = ref(false);
		const selectedAddOnsState = ref([]);
		const hiddenProduct = ref([]);
		const isSubmitting = ref(false);
		const doesSubAdnExist = ref(false);
		const addOnDiscount = ref(null);
		// console.log(addOnConfigState, "state");

		onMounted(async () => {
			isLoading.value = true;			
			if(addOnConfigState.value && addOnConfigState.value.add_ons.length > 0){
				let addOns = addOnConfigState.value.add_ons;
				await Promise.all(
					addOns.map(async (a) => {
						if (!a.hidden) {
							a.products = await Promise.all(
								a.products.map(async (p) => {
									let ogInfo = await getOGSellingPlans(p.id);
									// console.log(ogInfo, "og info");
									if (ogInfo.groups.length && ogInfo.groups[0].group_type === "incentive") {
										return { ...p, ...{ og_discount: parseInt(ogInfo.groups[0].name.split("-")[0]) } };
									}
									return p;
								})
							);
						} else {
							hiddenProduct.value.push(a.products[0]);
						}
					})
				);
				addOnConfigState.value.add_ons = addOns;	
				// console.log(addOnConfigState.value.add_ons, "addons");
				// console.log(hiddenProduct.value, "hidden product");
				
				// add on available so hidding the default add to cart
				if(addOnConfigState.value.add_ons && addOnConfigState.value.add_ons.length > 0){					
					let defaultATCBtn = document.querySelector('.product-info__buy-buttons');
					if(defaultATCBtn){
						defaultATCBtn.style.display = "none";
					}
				}
			}
			isLoading.value = false;
		});

		watch(selectedAddOnsState, () => {
			doesSubAdnExist.value = selectedAddOnsState.value.some((p) => p.purchase_type === "SUBSCRIPTION");
			updateAddonDiscount();
		});

		watch(addOnDiscount, () => disPatchAddonDiscount());

		function updateAddonDiscount() {
			let addOnDiscountTmp = [];
			addOnDiscountTmp = selectedAddOnsState.value.map((p) => {
				// console.log(p, "iterating");
				if (p.enable_discount != "NONE") {
					if (
						(p.purchase_type === "SUBSCRIPTION" && p.enable_discount === "SUBSCRIPTION") ||
						p.enable_discount === "BOTH"
					) {
						return {
							discount_value: parseFloat(p.subscription_discount_value),
							discount_type: p.subscription_discount_value_type,
						};
					}
					if ((p.purchase_type === "ONE_TIME" && p.enable_discount === "ONE_TIME") || p.enable_discount === "BOTH") {
						return {
							discount_value: parseFloat(p.subscription_discount_value),
							discount_type: p.subscription_discount_value_type,
						};
					}
				}
				return null;
			});
			addOnDiscount.value = addOnDiscountTmp;
			// console.log(addOnDiscount.value);
		}

		function disPatchAddonDiscount() {
			window.addOnDiscount = addOnDiscount.value;
			// console.log(window.addOnDiscount, "add on discount");
			window.updatePrice();
			// price update function should be invoked here
		}

		async function getOGSellingPlans(productId) {
			try {
				let resp = await fetch(
					`https://us-central1-shopify-web-dev.cloudfunctions.net/OGIncentiveHC?productId=${productId}`,
					{
						method: "GET",
					}
				);
				return resp.json();
			} catch (error) {
				console.log(error);
			}
		}

		function handleAddOnSelect(e) {
			if (selectedAddOnsState.value.some((s) => s.add_on_index === e.add_on_index)) {
				selectedAddOnsState.value = selectedAddOnsState.value.map((s) => {
					return s.add_on_index === e.add_on_index ? e : s;
				});
			} else {
				selectedAddOnsState.value.push(e);
			}
		}

		async function handleAddToCart() {
			let mainProduct = {
				quantity: 1,
				id: parseInt(document.querySelector(".product-info__buy-buttons input[name='id']").value),
			};

			let cartPayload = selectedAddOnsState.value.map((p) => {
				let lineItem = {
					quantity: 1,
					id: p.variant_id,
				};
				if (p.purchase_type === "SUBSCRIPTION") {
					lineItem.selling_plan = parseInt(p.selling_plan_id);
				}
				return lineItem;
			});
			let hiddenProducts = hiddenProduct.value.map((p) => {
				return {
					quantity: 1,
					id: p.id,
				};
			});

			cartPayload = [mainProduct, ...cartPayload, ...hiddenProducts];
			try {
				isSubmitting.value = true;
				if (addOnConfigState.value.redirect_to_checkout) Rebuy.SmartCart.skip_open = true;

				await fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ items: cartPayload }),
				}).then((resp) => resp.json());
				if (addOnConfigState.value.redirect_to_checkout) {
					let str = window.location.href.includes("/es/") ? "?locale=es" : "";
					str = "/checkout" + str;
					window.location.href = str;
				}
			} catch (error) {
				console.log(error);
			} finally {
				isSubmitting.value = false;
			}
		}

		function handleAddOnUpdate(e) {
			// console.log(e, "event");
			if (selectedAddOnsState.value.some((s) => s.variant_id === e.variant_id)) {
				selectedAddOnsState.value = selectedAddOnsState.value.map((s) => {
					return s.variant_id === e.variant_id
						? {
								...s,
								purchase_type: e.purchase_type,
						  }
						: s;
				});
			}
		}

		function handleAddOnDisabled(e) {
			// console.log(e, "event");
			if (selectedAddOnsState.value.some((s) => s.variant_id === e.variant_id)) {
				selectedAddOnsState.value = selectedAddOnsState.value.filter((s) => s.variant_id != e.variant_id);
			}
		}

		return {
			imgUrl,
			addOnConfigState,
			isLoading,
			selectedAddOnsState,
			handleAddOnSelect,
			handleAddOnUpdate,
			handleAddOnDisabled,
			handleAddToCart,
			hiddenProduct,
			isSubmitting,
			doesSubAdnExist,
			addOnDiscount,
		};
	},
	delimiters: ["${", "}"],
});

app.component("add-on-block", {
	template: "#add-on-block",
	emits: ["on-addon-select", "on-addon-update", "on-addon-disabled"],
	props: ["add_on", "index"],
	setup(props, ctx) {
		const isSelected = ref(false);
		const selectedProduct = ref([]);
		const dropdownOpen = ref(false);
		const isAddOnEnabled = ref(false);
		const purchaseOptions = [
			{
				type: "SUBSCRIPTION",
				label: "Monthly Subscription",
			},
			{
				type: "ONE_TIME",
				label: "One Time Purchase",
			},
		];
		onBeforeMount(() => {
			props.add_on.products = props.add_on.products.map((p) => {
				return {
					...p,
					...calculateDiscount(p),
					...{ og_selling_plan_id: getOGActiveSellingPlan(p.selling_plan_allocations) },
				};
			});
			// console.log(props, "block props");
			if (props.add_on.mandatory) {
				isAddOnEnabled.value = true;
				handeVariantSelect(props.add_on.products.find((p) => p.available === true));
			}
		});

		function getOGActiveSellingPlan(plans) {
			let og_selling_plan_id = null;
			for (let i = 0; i < plans.length; i++) {
				let sellingPlanAllocation = plans[i];
				let sellingPlan = sellingPlanAllocation.selling_plan;

				if (
					sellingPlan.recurring_deliveries &&
					sellingPlan.name.includes("Delivered") &&
					(sellingPlan.name.includes("30") || sellingPlan.name.includes("4 week"))
				) {
					og_selling_plan_id = sellingPlan.id;
					break; // exit the loop
				}
			}
			return og_selling_plan_id;
		}

		function toggleAddOnEnable() {
			isAddOnEnabled.value = !isAddOnEnabled.value;
			if (!isAddOnEnabled.value && selectedProduct.value.length) {
				ctx.emit("on-addon-disabled", { variant_id: selectedProduct.value[0].id });
				selectedProduct.value = [];
			}
		}

		function handeVariantSelect(product) {
			selectedProduct.value = [product];
			if (props.add_on.purchase_type_option != "BOTH") {
				if (
					selectedProduct.value[0].selling_plan_allocations.length > 0 &&
					props.add_on.purchase_type_option === "SUBSCRIPTION"
				) {
					selectedProduct.value[0].purchase_type = props.add_on.purchase_type_option;
				} else {
					selectedProduct.value[0].purchase_type = "ONE_TIME";
				}
			} else {
				if (
					props.add_on.default_purchase_type === "SUBSCRIPTION" &&
					selectedProduct.value[0].selling_plan_allocations.length > 0
				) {
					selectedProduct.value[0].purchase_type = props.add_on.default_purchase_type;
				} else {
					selectedProduct.value[0].purchase_type = "ONE_TIME";
				}
			}
			// console.log(selectedProduct.value[0].selling_plan_allocations.length, "selling plan");
			if (!isSelected.value) isSelected.value = true;
			ctx.emit("on-addon-select", {
				variant_id: selectedProduct.value[0].id,
				add_on_index: props.index,
				purchase_type: selectedProduct.value[0].purchase_type,
				enable_discount: props.add_on.enable_discount,
				one_time_discount_value: props.add_on.one_time_discount_value,
				one_time_discount_value_type: props.add_on.one_time_discount_value_type,
				subscription_discount_value_type: props.add_on.subscription_discount_value_type,
				subscription_discount_value: props.add_on.subscription_discount_value,
				selling_plan_id: selectedProduct.value[0].og_selling_plan_id,
			});
			dropdownOpen.value = false;
		}

		function handleRadioCheck(product) {
			let checked = false;
			if (selectedProduct.value.length && selectedProduct.value[0].id === product.id) checked = true;
			return checked;
		}

		function toggleDropdown() {
			dropdownOpen.value = !dropdownOpen.value;
		}

		function handlePurchasePlanSelect(type) {
			if (type === "SUBSCRIPTION" && selectedProduct.value[0].selling_plan_allocations.length > 0) {
				selectedProduct.value[0].purchase_type = type;
			} else {
				selectedProduct.value[0].purchase_type = "ONE_TIME";
			}
			ctx.emit("on-addon-update", {
				variant_id: selectedProduct.value[0].id,
				purchase_type: selectedProduct.value[0].purchase_type,
			});
		}

		return {
			imgUrl,
			formatMoneyy,
			handeVariantSelect,
			toggleDropdown,
			handleRadioCheck,
			calculateDiscountedPrice,
			handlePurchasePlanSelect,
			toggleAddOnEnable,
			isSelected,
			selectedProduct,
			dropdownOpen,
			purchaseOptions,
			isAddOnEnabled,
		};
	},
	delimiters: ["${", "}"],
});

app.component("subscription-benefit-block", {
	template: "#subscription-benefit-block",
	props: ["subs_benefit"],
	setup(props) {},
	delimiters: ["${", "}"],
});

app.mount("#productAddonBlock");

function imgUrl(url, size) {
	// remove any current image size then add the new image size
	return url
		.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".")
		.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
			return "_" + size + match;
		});
}

function calculateDiscount(p) {
	let currentVariant = p;
	let sellingPlansSize = currentVariant.selling_plan_allocations ? currentVariant.selling_plan_allocations.length : 0;
	let slashedOutPrice = currentVariant.price;
	let discountArray = [];
	let isDiscountOn = false;
	let priorityDiscountValue = 0;
	let discountAppliesTo = null;
	let collectionDiscount = 0;
	let sitewideDiscount = 0;
	let discountValue = 0;
	let discountAmount = 0;

	if (currentVariant.compare_at_price > currentVariant.price) {
		slashedOutPrice = currentVariant.compare_at_price;
	}

	if (currentVariant.site_wide_discount_value !== null && currentVariant.site_wide_discount_value !== "") {
		sitewideDiscount = parseFloat(currentVariant.site_wide_discount_value);
	}

	for (let collection of currentVariant.collections) {
		// console.log(collection);
		if (
			currentVariant.collection_disc_check &&
			collection.metafields.collection_discount &&
			collection.metafields.collection_discount !== null
		) {
			// console.log(collection.metafields, "metafields collections");
			if (collection.metafields.prioritize_discount) {
				priorityDiscountValue = parseFloat(collection.metafields.collection_discount);
			}
			if (collection.metafields.discount_applies_to) {
				discountAppliesTo = collection.metafields.discount_applies_to[0];
			}
			discountArray.push(parseFloat(collection.metafields.collection_discount));
		}
	}

	if (discountArray.length) {
		collectionDiscount = Math.max(...discountArray);
	}

	if (!currentVariant.site_wide_discount && !currentVariant.collection_disc_check) {
		discountValue = 0;
		isDiscountOn = false;
	}

	if (currentVariant.site_wide_discount) {
		discountValue = sitewideDiscount;
		isDiscountOn = true;
	}

	if (currentVariant.collection_disc_check) {
		discountValue = collectionDiscount;
		isDiscountOn = true;
	}

	if (currentVariant.collection_disc_check && priorityDiscountValue <= 0 && sitewideDiscount >= collectionDiscount) {
		discountValue = sitewideDiscount;
		isDiscountOn = true;
	}

	if (priorityDiscountValue > 0 && currentVariant.collection_disc_check) {
		discountValue = priorityDiscountValue;
		isDiscountOn = true;
	}

	if (currentVariant.variant_discount && currentVariant.variant_discount > 0) {
		discountValue = currentVariant.variant_discount;
		isDiscountOn = true;
	}

	let discountPercentage = discountValue;
	discountAmount = (discountValue / 100) * currentVariant.price;
	discountValue = currentVariant.price - discountAmount;

	if (isDiscountOn || sellingPlansSize > 0) {
		if (discountValue < currentVariant.price) {
			return {
				slashed_price: slashedOutPrice,
				ado_price: discountValue,
				discount_percentage: discountPercentage,
				discount_applies_to: discountAppliesTo,
			};
		} else {
			return {
				slashed_price: null,
				ado_price: currentVariant.price,
				discount_percentage: discountPercentage,
				discount_applies_to: discountAppliesTo,
			};
		}
	} else {
		if (currentVariant.compare_at_price > currentVariant.price) {
			return {
				slashed_price: currentVariant.compare_at_price,
				ado_price: currentVariant.price,
			};
		} else {
			return {
				slashed_price: null,
				ado_price: currentVariant.price,
			};
		}
	}
}

function formatMoneyy(cents, format = "") {
	if (typeof cents === "string") {
		cents = cents.replace(".", "");
	}
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
		formatString = format || window.themeVariables.settings.moneyFormat;
	function defaultTo(value2, defaultValue) {
		return value2 == null || value2 !== value2 ? defaultValue : value2;
	}
	function formatWithDelimiterss(number, precision, thousands, decimal) {
		precision = defaultTo(precision, 2);
		thousands = defaultTo(thousands, ",");
		decimal = defaultTo(decimal, ".");
		if (isNaN(number) || number == null) {
			return 0;
		}
		number = roundNumber(number / 100, false, precision);
		let parts = number.split("."),
			dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
			centsAmount = parts[1] ? decimal + parts[1] : "";
		return dollarsAmount + centsAmount;
	}
	let value = "";
	switch (formatString.match(placeholderRegex)[1]) {
		case "amount":
			value = formatWithDelimiterss(cents, 2);
			break;
		case "amount_no_decimals":
			value = formatWithDelimiterss(cents, 0);
			break;
		case "amount_with_space_separator":
			value = formatWithDelimiterss(cents, 2, " ", ".");
			break;
		case "amount_with_comma_separator":
			value = formatWithDelimiterss(cents, 2, ".", ",");
			break;
		case "amount_with_apostrophe_separator":
			value = formatWithDelimiterss(cents, 2, "'", ".");
			break;
		case "amount_no_decimals_with_comma_separator":
			value = formatWithDelimiterss(cents, 0, ".", ",");
			break;
		case "amount_no_decimals_with_space_separator":
			value = formatWithDelimiterss(cents, 0, " ");
			break;
		case "amount_no_decimals_with_apostrophe_separator":
			value = formatWithDelimiterss(cents, 0, "'");
			break;
	}
	if (formatString.indexOf("with_comma_separator") !== -1) {
		return formatString.replace(placeholderRegex, value);
	} else {
		return formatString.replace(placeholderRegex, value);
	}
}

function roundNumber(num, savings, precision = 2) {
	if (isNaN(num)) {
		return;
	}

	let nummm = num.toFixed(3).split(".")[1].slice(2);
	if (nummm > 4 && !savings) {
		let number = Math.ceil((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	} else if (nummm < 6 && savings) {
		let number = Math.floor((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	} else {
		let number = Math.round((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	}
}

function calculateDiscountedPrice(salePrice = 0, discount = 0) {
	if (salePrice < 0 || discount < 0) {
		throw "Sale price and discount must be non-negative values.";
	}

	const discountAmount = (discount / 100) * salePrice;
	const discountedPrice = salePrice - discountAmount;

	return discountedPrice;
}
